// extracted by mini-css-extract-plugin
module.exports = {"root":"ScreenReaderOnly_root__6HR83"};